<template>
  <div class="floatbox" @click="floatboxClick" :class="{'floatbox-enter-active': state, 'floatbox-leave-active': !state}">
  </div>
</template>

<script>
  export default {
    name: 'FloatBox',
    data() {
      return {
        state: false
      }
    },
    methods: {
      floatboxClick() {
        var cosParameter = window.scrollY / 2,
          scrollCount = 0,
          oldTimestamp = performance.now();

        function step(newTimestamp) {
          scrollCount += Math.PI / (500 / (newTimestamp - oldTimestamp));
          if (scrollCount >= Math.PI) window.scrollTo(0, 0);
          if (window.scrollY === 0) return;
          window.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)));
          oldTimestamp = newTimestamp;
          window.requestAnimationFrame(step);
        }
        window.requestAnimationFrame(step);
      },
      scrollEvent() {
        //还有点问题
        var a = 700;
        var b = window.scrollY;
        if (b > a) {
          this.state = true
        } else {
          this.state = false
        }
      }
    },
    created() {
      window.addEventListener('scroll', this.scrollEvent);
    }
  }
</script>

<style scoped>
  .floatbox {
    position: fixed;
    right: 32px;
    bottom: 200px;
    z-index: 19;
    width: 50px;
    height: 50px;
    background: url(../assets/images/index/top.png) no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    opacity: 0;
  }

  .floatbox-enter-active {
    -webkit-animation: fade-in 0.5s ease-out;
    -moz-animation: fade-in 0.5s ease-out;
    -o-animation: fade-in 0.5s ease-out;
    animation: fade-in 0.5s ease-out;
    -webkit-animation-fill-mode: forwards;
    -moz-animation-fill-mode: forwards;
    -o-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }

  .floatbox-leave-active {
    -webkit-animation: fade-in 0.5s ease-out reverse;
    -moz-animation: fade-in 0.5s ease-out reverse;
    -o-animation: fade-in 0.5s ease-out reverse;
    animation: fade-in 0.5s ease-out reverse;
    -webkit-animation-fill-mode: forwards;
    -moz-animation-fill-mode: forwards;
    -o-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
  }

  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/floatbox.vue